import React, { Component } from 'react';

import AppStore from '../../lib/flux/AppStore';
import AppActionTypes from '../../lib/flux/AppActionTypes';

import Modal from '../../components/Modal/Modal';
import Stream from '../../components/Stream/Stream';

class Modals extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...AppStore.getModal()
        }
    }

    componentDidMount = () => {
        AppStore.on(AppActionTypes.MODAL, this._handleChange);
    }

    componentWillUnmount = () => {
        AppStore.removeListener(AppActionTypes.MODAL, this._handleChange);
    }

    _handleChange = (state) => {
        this.setState(state);
    }

    render() {
        const { stream } = this.state;
        return (
            <div className={`Modals`}>
                <div className={`modals-container`}>
                    <Modal
                        show={stream}
                        onCloseClick={() => {
                            AppStore._setModal({ stream: false })
                        }}
                        onOverlayClick={() => {
                            AppStore._setModal({ stream: false })
                        }}
                    >
                        <Stream />
                    </Modal>
                </div>
            </div>
        );
    }
}

export default Modals;